import type { Product } from "~/types/ecom/product/product.type";

//---- filter branches by specified details
export async function handleNearByStockSearch(details: {
  latitude: string;
  longitude: string;
  productCode: string;
  requiredQuantity: number;
}) {
  const {latitude , longitude, productCode, requiredQuantity} = details;
  const stockStore = useStockStore();

  const nearestBranchRequestBody = {
    latitude,
    longitude,
  };

  await stockStore.getNearByStock(
    productCode,
    requiredQuantity,
    nearestBranchRequestBody
  );
};

export function isProductOutOfStock(
  product: Product,
  skipCheckNotifyMe = false
) {
  if (!skipCheckNotifyMe && !checkNotifyMeOption(product)) return false;
  //---- show notify me for directship product if quantity exceeds stock
  if (product.direct_ship) return product.outOfStockForDelivery;
  //---- show notify me when branch is set and we are sure about collection stock
  return product.outOfStockForCollection && product.outOfStockForDelivery;
}
